import Immutable from 'immutable'
import moment from 'moment'
import { apiHandleStatus, jsonParse } from '../../lib/index'

import MainReducer from '../main/reducer'
import capiSingleton from '../../api/carrotApi'
const capi = capiSingleton.get()

const TYPES = {
    CLEAR: 'LISTBOARD_CLEAR',
    SET_FULL_LOADING: 'LISTBOARD_SET_FULL_LOADING',
    SET_WEEKLY_LOADING: 'LISTBOARD_SET_WEEKLY_LOADING',
    SET_ERROR: 'LISTBOARD_SET_ERROR',
    SET_FULL_TRANSACTIONS: 'LISTBOARD_SET_FULL_TRANSACTIONS',
    SET_NO_FULL_TRANSACTIONS: 'LISTBOARD_SET_NO_FULL_TRANSACTIONS',
    SET_WEEKLY_TRANSACTIONS: 'LISTBOARD_SET_WEEKLY_TRANSACTIONS',
    SET_NO_WEEKLY_TRANSACTIONS: 'LISTBOARD_SET_NO_WEEKLY_TRANSACTIONS'
}

export default class ListboardReducer {
    static componentName = 'ListboardReducer'
    static NAME = 'listboard_reducer'
    static TYPES = TYPES
    static INITIAL_STATE = Immutable.fromJS({})

    static clear() {
        return (dispatch, getState) => dispatch({ type: TYPES.CLEAR })
    }

    static setFullLoading() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_FULL_LOADING
            })
        }
    }

    static setWeeklyLoading() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_WEEKLY_LOADING
            })
        }
    }

    static setError(
        error
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_ERROR,
                error
            })
        }
    }

    static setFullTransactions(
        transactions
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_FULL_TRANSACTIONS,
                transactions
            })
        }
    }

    static setNoFullTransactions() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_NO_FULL_TRANSACTIONS
            })
        }
    }

    static setWeeklyTransactions(
        transactions
    ) {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_WEEKLY_TRANSACTIONS,
                transactions
            })
        }
    }

    static setNoWeeklyTransactions() {
        return (dispatch, getState) => {
            dispatch({
                type: TYPES.SET_NO_WEEKLY_TRANSACTIONS
            })
        }
    }

    static fetchFullTransactions(
        count
    ) {
        return (dispatch, getState) => {
            // const today = moment().toISOString()
            // const period = moment(today).subtract(3, 'month').toISOString()

            let params = {
                count: count,
                // pub_date__gte: period,
                // pub_date__lte: today
            }

            dispatch(ListboardReducer.setFullLoading())

            return capi.Income.retrieve(
                null,
                params
            ).then((res) => {
                apiHandleStatus(res, [200])

                if (res.data.results.length > 0) {
                    dispatch(this.setFullTransactions(
                        res.data.results.map((r) =>{
                            let transaction_context = jsonParse(r.transaction_context)

                            // date format in weird non-standard format like '2021/01/01 00:00:00.000'
                            // so we have to hack in place
                            transaction_context.transaction_date = transaction_context.transaction_date.substring(0, 10)
                            transaction_context.redemption_date = transaction_context.redemption_date.substring(0, 10)
                            transaction_context.first_transaction_date = transaction_context.first_transaction_date.substring(0, 10)

                            return { ...r, transaction_context }
                        }).sort((a, b) => {
                            // Sorting by pub_date by FIFO
                            // if(a.pub_date < b.pub_date) {
                            //     return -1
                            // } else if (a.pub_date > b.pub_date) {
                            //     return 1
                            // } else {
                            //     return 0
                            // }

                            // Sorting by redemption_date by FIFO
                            // return moment.utc(a.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')
                            //         - moment.utc(b.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')

                            // Sorting by redemption_date by LIFO
                            return moment.utc(b.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')
                                    - moment.utc(a.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')
                        })
                    ))
                } else {
                    dispatch(this.setNoFullTransactions())
                }

            }).catch((error) => {
                dispatch(ListboardReducer.setError(error))
            })
        }
    }

    static fetchWeeklyTransactions(
        start,
        end
    ) {
        return (dispatch, getState) => {
            let params = {
                count: 10000,
                pub_date__gte: start,
                pub_date__lte: end
            }

            dispatch(ListboardReducer.setWeeklyLoading())

            return capi.Income.retrieve(
                null,
                params
            ).then((res) => {
                apiHandleStatus(res, [200])

                if (res.data.results.length > 0) {
                    dispatch(this.setWeeklyTransactions(
                        res.data.results.map((r) =>{
                            let transaction_context = jsonParse(r.transaction_context)

                            // date format in weird non-standard format like '2021/01/01 00:00:00.000'
                            // so we have to hack in place
                            transaction_context.transaction_date = transaction_context.transaction_date.substring(0, 10)
                            transaction_context.redemption_date = transaction_context.redemption_date.substring(0, 10)
                            transaction_context.first_transaction_date = transaction_context.first_transaction_date.substring(0, 10)

                            return { ...r, transaction_context }
                        }).sort((a, b) => {
                            // Sorting by redemption_date by FIFO
                            return moment.utc(a.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')
                                    - moment.utc(b.transaction_context.transaction_date, 'YYYY/MM/DD').format('X')
                        })
                    ))
                } else {
                    dispatch(this.setNoWeeklyTransactions())
                }

            }).catch((error) => {
                dispatch(ListboardReducer.setError(error))
            })
        }
    }

    static reducer(
        state = ListboardReducer.INITIAL_STATE,
        action
    ) {
        if (state == null) state = ListboardReducer.INITIAL_STATE

        switch (action.type) {
            case MainReducer.TYPES.LOGOUT:
            case TYPES.CLEAR:
                return ListboardReducer.INITIAL_STATE

            case MainReducer.TYPES.SWITCH_CURRENT_IDENTITY:
                action.asyncDispatch(ListboardReducer.fetchFullTransactions())
                return ListboardReducer.INITIAL_STATE

            case TYPES.SET_FULL_LOADING:
                return state.delete('error')
                        .set('fullLoading', true)

            case TYPES.SET_ERROR:
                return state.delete('fullLoading')
                    .delete('noFullTransactions')
                    .delete('fullTransactions')
                    .set('error', action.error)

            case TYPES.SET_FULL_TRANSACTIONS:
                return state.delete('fullLoading')
                        .delete('error')
                        .delete('noFullTransactions')
                        .set('fullTransactions', Immutable.fromJS(action.transactions))

            case TYPES.SET_NO_FULL_TRANSACTIONS:
                return state.delete('fullLoading')
                        .delete('error')
                        .set('noFullTransactions', true)

            case TYPES.SET_WEEKLY_LOADING:
                return state.delete('error')
                        .set('weeklyLoading', true)

            case TYPES.SET_WEEKLY_TRANSACTIONS:
                return state.delete('weeklyLoading')
                        .delete('error')
                        .delete('noWeeklyTransactions')
                        .set('weeklyTransactions', Immutable.fromJS(action.transactions))

            case TYPES.SET_NO_WEEKLY_TRANSACTIONS:
                return state.delete('weeklyLoading')
                        .delete('error')
                        .set('noWeeklyTransactions', true)

            default:
                return state
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/listboard/reducer.js